export function getStatusColor(status: string): string {
  switch (status) {
    case 'uncontacted':
      return 'bg-gray-100 text-gray-800';
    case 'cold':
      return 'bg-blue-100 text-blue-800';
    case 'warm':
      return 'bg-yellow-100 text-yellow-800';
    case 'hot':
      return 'bg-orange-100 text-orange-800';
    case 'enrolled':
      return 'bg-green-100 text-green-800';
    case 'lost':
      return 'bg-red-100 text-red-800';
    case 'dnc':
      return 'bg-gray-800 text-white';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function getDeterminationColor(determination?: string): string {
  switch (determination) {
    case 'interested':
      return 'bg-green-100 text-green-800';
    case 'not_interested':
      return 'bg-red-100 text-red-800';
    case 'not_home':
      return 'bg-yellow-100 text-yellow-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
